import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenewalOverviewComponent } from './renewal-overview/renewal-overview.component';
import { HeaderModule } from '../header/header.module';
import { HomeModule } from '../home/home.module';
import { RouterModule } from '@angular/router';
import { ManageRenewalsComponent } from './manage-renewals/manage-renewals.component';
import { OnlineActivityComponent } from './manage-renewals/online-activity/online-activity.component';
import { LobsQuotelistComponent } from './lobs-quotelist/lobs-quotelist.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductInstanceComponent } from './manage-renewals/product-instance/product-instance.component';
import { BindAndIssueModule } from './bind-and-issue/bind-and-issue.module';
import { StartRenewalModule } from './start-renewal/start-renewal.module';
import { ChangeRenewalRequestModule } from './change-renewal-request/change-renewal-request.module';



@NgModule({
  declarations: [RenewalOverviewComponent, ManageRenewalsComponent, OnlineActivityComponent, LobsQuotelistComponent, ProductInstanceComponent],
  imports: [
    CommonModule,
    NgbModule,
    HeaderModule,
    HomeModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    BindAndIssueModule,
    StartRenewalModule,
    ChangeRenewalRequestModule,
  ]
})
export class RenewalsModule { }
